<template>
  <md-card-content>
    <!-- 登記情報提供サービス-->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>登記情報提供サービスID</label>
      </div>
      <div class="md-layout-item md-size-40">
        <div class="md-layout md-alignment-center-space-between">
          <md-field>
            <label>{{ t_service_id }}</label>
          </md-field>
        </div>
      </div>
    </div>
  </md-card-content>
</template>

<script>
export default {
  name : 'ContractPreviewTService',
  props: ['t_service_id'],
}
</script>

<style lang="scss" scoped>
</style>
